import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useSubheader } from '../../../_metronic/layout/_core/MetronicSubheader';
import { JdsSkeleton } from '../../components/jds/JdsSkeleton';
import { useTweenedNumber } from '../../hooks/useTweenedNumber';
import { prefersReducedMotion } from '../../helpers/motion';
import '../../components/jds/jds.css';
import './dashboard.css';

const ACTION_CLASS =
  'jds-btn jds-btn--ghost jds-btn--brand jds-btn--sm dashboard-stat__action';

// Número que conta de 0 até o valor quando o card aparece. Só para inteiros: qualquer outro
// valor (texto, decimal) é exibido como veio, então o final é sempre idêntico ao original.
function CountUp({ value }) {
  const number = Number(value);
  const countable = value !== '' && value != null && Number.isInteger(number);
  const [target, setTarget] = useState(() =>
    prefersReducedMotion() ? number : 0,
  );
  useEffect(() => {
    setTarget(number);
  }, [number]);
  const shown = useTweenedNumber(countable ? target : NaN, 600);

  return countable ? Math.round(shown) : value ?? '';
}

function StatCardSkeleton() {
  return (
    <div className="jds-card dashboard-stat" aria-hidden="true">
      <JdsSkeleton width="45%" height={20} />
      <JdsSkeleton width="30%" height={35} />
      <JdsSkeleton
        width={96}
        height={32}
        style={{ marginTop: 'var(--space-8)' }}
      />
    </div>
  );
}

function StatCard({ label, value, to, href, tone }) {
  return (
    <div
      className={`jds-card dashboard-stat${
        tone === 'error' ? ' dashboard-stat--error' : ''
      }`}
    >
      <p className="dashboard-stat__label">{label}</p>
      <p className="dashboard-stat__value">
        <CountUp value={value} />
      </p>
      {to && (
        <Link to={to} className={ACTION_CLASS}>
          Visualizar
        </Link>
      )}
      {href && (
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className={ACTION_CLASS}
        >
          Visualizar
        </a>
      )}
    </div>
  );
}

export function DashboardJds() {
  const dashboard = useSelector((state) => state.app.dashboard);
  const isLoading = useSelector((state) => state.app.is_dashboard_loading);
  const { user } = useSelector((state) => state.auth);
  const subheader = useSubheader();
  const dispatch = useDispatch();
  // Antes do 1º dispatch o redux ainda tem o estado antigo (ou vazio): mostra skeleton, não cards em branco.
  const [requested, setRequested] = useState(false);

  useEffect(() => {
    dispatch({ type: 'LOAD_DASHBOARD' });
    setRequested(true);
    subheader.setBreadcrumbs([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="jds-scope">
      <h1 className="jds-title-lg mb-10 jds-enter">
        Seja bem-vindo, {user.name.split(' ')[0]}
      </h1>
      {isLoading || !requested ? (
        <div className="dashboard-grid" role="status" aria-label="Carregando">
          {[0, 1, 2, 3].map((i) => (
            <StatCardSkeleton key={i} />
          ))}
        </div>
      ) : (
        <div className="dashboard-grid jds-stagger">
          <StatCard
            label="Clientes"
            value={dashboard.customers}
            to="/clientes"
          />
          <StatCard
            label="Cadastros hoje"
            value={dashboard.registers_today}
            to="/clientes"
          />
          {!!dashboard.paid && (
            <StatCard
              label="Clientes em dia"
              value={dashboard.paid}
              href="https://dashboard.pagar.me/"
            />
          )}
          {!!dashboard.active && (
            <StatCard
              label="Clientes ativos"
              value={dashboard.active}
              href="https://dashboard.pagar.me/"
            />
          )}
          <StatCard
            label="Cancelamentos de clientes hoje"
            value={dashboard.canceled}
            to="/cancelados/clientes"
            tone="error"
          />
          <StatCard
            label="Cancelamentos que pagaram 1x"
            value={dashboard.canceled_recent}
            to="/cancelados/recente"
            tone="error"
          />
        </div>
      )}
    </div>
  );
}
